import moment from "moment";

export const INVOICE_GENERATED_COLUMNS = [
  {
    Header: "Invoice #",
    accessor: "InvoiceNumber",
    id: "InvoiceNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Invoice Batch #",
    accessor: "InvoiceBatchNumber",
    id: "InvoiceBatchNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Invoice Date",
    accessor: "InvoiceDate",
    id: "InvoiceDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : ""
  },
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },

  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To #",
    accessor: "BillToNumber",
    id: "BillToNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To Name",
    accessor: "BillToName",
    id: "BillToName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Route",
    accessor: "RouteId",
    id: "RouteId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Route Description",
    accessor: "RouteDescription",
    id: "RouteDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Delivery Date",
    accessor: "RequestedDeliveryDate",
    id: "RequestedDeliveryDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Verified By",
    accessor: "VerifiedByUserId",
    id: "VerifiedByUserId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  }
];

export const BILLING_VERIFIED_COLUMNS = [
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To #",
    accessor: "BillToNumber",
    id: "BillToNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To Name",
    accessor: "BillToName",
    id: "BillToName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Route",
    accessor: "RouteId",
    id: "RouteId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Delivery Date",
    accessor: "ScheduledDeliveryDate",
    id: "ScheduledDeliveryDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  }
];

export const BILLING_VERIFIED_INVOICE_COLUMNS = showBatchNo => {
  let columns = [
    {
      Header: "Invoice #",
      accessor: "InvoiceNumber",
      id: "InvoiceNumber",
      Cell: ({ cell }) => (cell.value ? cell.value : "")
    },
    {
      Header: "Order #",
      accessor: "OrderNumber",
      id: "OrderNumber",
      Cell: ({ cell }) => (cell.value ? cell.value : "")
    },
    {
      Header: "Invoice Date",
      accessor: "InvoiceDate",
      id: "InvoiceDate",
      Cell: ({ cell }) =>
        cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
    }
  ];
  if (showBatchNo) {
    columns = [
      ...columns,
      {
        Header: "Invoice Batch No",
        accessor: "InvoiceBatchNumber",
        id: "InvoiceBatchNumber",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      }
    ];
  }
  columns = [
    ...columns,
    ...[
      {
        Header: "Customer #",
        accessor: "CustomerNo",
        id: "CustomerNo",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      },
      {
        Header: "Customer Name",
        accessor: "CustomerName",
        id: "CustomerName",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      },
      {
        Header: "Bill To #",
        accessor: "BillToNumber",
        id: "BillToNumber",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      },
      {
        Header: "Bill To Name",
        accessor: "BillToName",
        id: "BillToName",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      },
      {
        Header: "Route",
        accessor: "RouteId",
        id: "RouteId",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      },
      {
        Header: "Pickup Date",
        accessor: "PickupDate",
        id: "PickupDate",
        Cell: ({ cell }) =>
          cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
      },
      {
        Header: "Delivery Date",
        accessor: "ScheduledDeliveryDate",
        id: "ScheduledDeliveryDate",
        Cell: ({ cell }) =>
          cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
      },
      {
        Header: "Status",
        accessor: "StatusIdDescription",
        id: "StatusIdDescription",
        Cell: ({ cell }) => (cell.value ? cell.value : "")
      }
    ]
  ];
  return columns;
};
